import { Injector, Optional } from '@angular/core';
import { LoadDrupalLangService } from '../services/load-drupal-lang.service';

export class DrupalLangClass {
  public drupalLangService;

  constructor(injector:Injector){
    this.drupalLangService = injector.get(LoadDrupalLangService);
  }

  /**
   * Get the lang prefix for drupal application.
   *
   * @readonly
   * @memberof AthleteNameComponent
   */
  get lang(){
    return this.drupalLangService ? this.drupalLangService.langPrefix : '/';
  }


}

